import { GET_EXPORTED_MENUS } from '../constants/ActionTypes';

export function getExportedMenus(path) {
  return {
    type: GET_EXPORTED_MENUS,
    request: {
      op: 'get',
      path: `${path}/@export-menus`,
    },
  };
}
